import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const ItemArIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M21 0.25H16.4C15.99 0.25 15.65 0.59 15.65 1C15.65 1.41 15.99 1.75 16.4 1.75H21C21.69 1.75 22.25 2.31 22.25 3V7.6C22.25 8.01 22.59 8.35 23 8.35C23.41 8.35 23.75 8.01 23.75 7.6V3C23.75 1.48 22.52 0.25 21 0.25Z"
        fill={color}
      />
      <path
        d="M1 8.35C1.41 8.35 1.75 8.01 1.75 7.6V3C1.75 2.31 2.31 1.75 3 1.75H7.6C8.01 1.75 8.35 1.41 8.35 1C8.35 0.59 8.01 0.25 7.6 0.25H3C1.48 0.25 0.25 1.48 0.25 3V7.6C0.25 8.01 0.59 8.35 1 8.35Z"
        fill={color}
      />
      <path
        d="M23 15.65C22.59 15.65 22.25 15.99 22.25 16.4V21C22.25 21.69 21.69 22.25 21 22.25H16.4C15.99 22.25 15.65 22.59 15.65 23C15.65 23.41 15.99 23.75 16.4 23.75H21C22.52 23.75 23.75 22.52 23.75 21V16.4C23.75 15.99 23.41 15.65 23 15.65Z"
        fill={color}
      />
      <path
        d="M7.6 22.25H3C2.31 22.25 1.75 21.69 1.75 21V16.4C1.75 15.99 1.41 15.65 1 15.65C0.59 15.65 0.25 15.99 0.25 16.4V21C0.25 22.52 1.48 23.75 3 23.75H7.6C8.01 23.75 8.35 23.41 8.35 23C8.35 22.59 8.01 22.25 7.6 22.25Z"
        fill={color}
      />
      <path
        d="M17.79 15V9C17.79 8.78 17.67 8.57 17.48 8.46L12.32 5.46C12.13 5.35 11.89 5.35 11.69 5.46L6.52997 8.46C6.33997 8.57 6.21997 8.78 6.21997 9V15C6.21997 15.22 6.33997 15.43 6.52997 15.54L11.69 18.54C11.88 18.65 12.12 18.65 12.32 18.54L17.48 15.54C17.67 15.43 17.79 15.22 17.79 15ZM12 6.72L15.95 9.02L12 11.28L8.04997 9.02L12 6.72ZM7.45997 10.13L11.37 12.36V16.91L7.45997 14.64V10.13ZM12.62 16.91V12.36L16.53 10.13V14.64L12.62 16.91Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

ItemArIcon.displayName = 'ItemArIcon';
